<template lang="pug">
  modal(:title='modalTitle' @closeModal='closeModal')
    .column(v-if='success')
      .column.middle.center
        simple-svg(:filepath='checkIcon' width='42px' height='42px')
        h2.text-center.title-medium.m-top-2 {{ $t('krea.publishContentModal.unpublishSuccess') }}
    .column.m-top-2(v-else)
      h2.text-normal(v-html='$t("krea.educationalContent.unpublishModal.msg", { contentTitle: this.modalProps.contentTitle })')
      .width-100.m-bottom-1
        k-select(
          withBorder
          :label='$t("krea.publishContentModal.language")'
          :emptyOption='$t("krea.publishContentModal.emptyLanguageOption")'
          :options='languagesOptions'
          name='locale'
          @selectOption='setLocale'
        )
      .row.middle.end.m-top-1
        button.secondary-button.m-right-2(@click='closeModal') {{ $t("krea.publishContentModal.cancel") }}
        button.primary-button(@click='submit') {{ $t('krea.publishContentModal.unpublish') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '@/components/Modal'
import { routes } from '../../router'
import KSelect from '@/components/KSelect'
import checkIcon from '@/assets/ic_check.svg'
import { educationalProgramLanguageStatus } from '../../utils/constants'
import { mapLanguageOptions, supportedLanguages } from '../../constants/languages'
import { i18n } from '../../main'

export default {
  components: { Modal, KSelect },
  data() {
    return {
      checkIcon,
      success: false,
      showError: false,
      locale: null
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.kreaUnpublishContentModal.props
    }),
    modalTitle() {
      if (this.success) return null
      else return i18n.t('krea.educationalContent.unpublishModal.title')
    },
    languagesOptions() {
      if (this.keywordsEditionMode) return null
      return supportedLanguages
        .filter(lang => this.modalProps.languages.includes(lang.lang))
        .map(mapLanguageOptions)
    }
  },
  methods: {
    ...mapActions([
      'hideElement',
      'setKreaEducationalContentStatus'
    ]),
    setLocale(name, value) {
      this.locale = value
    },
    closeModal() {
      this.hideElement({ element: 'kreaUnpublishContentModal' })
      if (this.success) this.$router.push({ name: routes.kreaPublished })
    },
    async submit() {
      this.showError = false
      const { success, error } = await this.setKreaEducationalContentStatus({
        id: this.modalProps.contentId,
        status: educationalProgramLanguageStatus.hidden,
        locales: this.locale ? [this.locale] : this.languagesOptions.map(lang => lang.id)
      })
      if (success) {
        this.success = true
      } else {
        this.showError = true
        this.$notify({
          group: 'custom-toast',
          duration: 5000,
          type: 'error',
          text: error
        })
      }
      this.$emit('success')
    }
  }
}
</script>

<style lang="scss">
@import 'src/scss/variables/colors';

.ti-tag{
  &.keyword{
    background-color: $blue !important;
    span{
      color: $white;
    }
    .ti-icon-close {
      color: $white;
      margin-left: 5px;
    }
  }
}
</style>
